import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "\n            d-flex\n            flex-column flex-root\n            position-absolute\n            min-w-100 min-h-100\n        " }
const _hoisted_2 = { class: "\n                login-view\n                d-flex\n                flex-center flex-column flex-column-fluid\n                p-sm-10\n            " }
const _hoisted_3 = { class: "\n                    login-block\n                    w-lg-500px\n                    bg-white\n                    rounded\n                    p-10 p-lg-15\n                    mx-auto\n                    anime-slide-top#xsmall\n                " }
const _hoisted_4 = { class: "text-center mb-10" }
const _hoisted_5 = { href: "https://multiorders.com" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3 fs-1" }, "log in")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "anime-slide-left#xsmall"
}
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "fv-row mb-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Email", -1)
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "fv-row mb-10" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, " Password ")
], -1)
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "d-flex flex-stack mb-10" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "\n                                form-check form-check-custom form-check-solid\n                            " }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-check-input",
    type: "checkbox",
    value: "",
    id: "flexCheckDefault",
    checked: "true"
  }),
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label",
    for: "flexCheckDefault"
  }, "Remember me")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400 fw-bold fs-7 btn-text-long" }, [
  /*#__PURE__*/_createTextVNode(" Don't have an account? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("div", { class: "link-primary fs-5" }, " Create an Account ")
], -1)
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Continue ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "\n                                        spinner-border spinner-border-sm\n                                        align-middle\n                                        ms-2\n                                    " })
], -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          class: "form w-100",
          id: "kt_login_signin_form",
          onSubmit: _ctx.onLoginSubmit,
          "validation-schema": _ctx.loginSchema
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("a", _hoisted_5, [
                _createElementVNode("img", {
                  alt: "Logo",
                  src: _ctx.originUrl + _ctx.logo,
                  class: "h-30px h-md-40px logo"
                }, null, 8, _hoisted_6)
              ])
            ]),
            _hoisted_7,
            (_ctx.messagesError.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messagesError, (message) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: message,
                      class: "mb-10 bg-light-danger p-8 rounded"
                    }, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(message), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode(_component_Field, {
                class: "\n                                form-control form-control-lg form-control-solid\n                            ",
                type: "text",
                name: "email",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_ErrorMessage, {
                    name: "email",
                    class: "anime-slide-left#xsmall d-block"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_component_Field, {
                class: "\n                                form-control form-control-lg form-control-solid\n                            ",
                type: "password",
                name: "password",
                autocomplete: "off"
              }),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_ErrorMessage, {
                    name: "password",
                    class: "anime-slide-left#xsmall d-block"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_router_link, {
                to: _ctx.signupLink,
                class: "mo-link-hovarable link-primary fs-5"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", _hoisted_22, _hoisted_25, 512)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"])
      ])
    ])
  ]))
}